import { useState } from 'react';
// @mui
import { Tabs, Tab } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useLocales from 'src/hooks/useLocales';
// ----------------------------------------------------------------------
import { PATH_DASHBOARD } from '../../../../routes/paths';

export default function UserTabs(props:any) {

  const { translate } = useLocales();
  
  const navigate = useNavigate();

  const PAGES_OPTIONS = [
    {
      text: translate('users.list.tabs.team_members'),
      nav: PATH_DASHBOARD.general.members
    },
    {
      text: translate('users.list.tabs.invited_members'),
      nav: PATH_DASHBOARD.general.invitations
    }
  ];

  return (
    <Tabs
      allowScrollButtonsMobile
      variant="scrollable"
      scrollButtons="auto"
      value={props.selectedTab}
    >
      {PAGES_OPTIONS.map((tab) => (
        <Tab disableRipple key={tab.text} label={tab.text} value={tab.text} onClick={() => navigate(tab.nav)} />
      ))}
    </Tabs>
  );
}
